/**
 * Constantes para o fluxo BAAS
 */

// Cache times para React Query
export const CACHE_TIME = 5 * 60 * 1000; // 5 minutos
export const ACCOUNT_CACHE_TIME = 60000; // 1 minuto

// Máscaras de input
export const MASK_PHONE = '(99) 99999-9999';
export const MASK_CEP = '99999-999';
export const MASK_DATE = '99/99/9999';
export const MASK_CPF = '999.999.999-99';
export const MASK_CNPJ = '**.***.***/****-99';

// Padrões de regex
export const REGEX_PHONE = /^\(\d{2}\)\s?\d{4,5}-?\d{4}$/;
export const REGEX_CEP = /^\d{5}-?\d{3}$/;
export const REGEX_DATE = /^\d{2}\/\d{2}\/\d{4}$/;
export const REGEX_CPF = /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/;
export const REGEX_DATE_ISO = /^\d{4}-\d{2}-\d{2}$/;

// Unidades federativas (UFs) válidas do Brasil
export const VALID_UFS = new Set([
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
  'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC',
  'SP', 'SE', 'TO',
]);

/**
 * Valida se a sigla informada é uma UF brasileira válida.
 * @param {string} uf - sigla da UF (ex.: "SP")
 * @returns {boolean}
 */
export const isValidUf = (uf) => VALID_UFS.has(String(uf || '').toUpperCase());

// Valores padrão
export const DEFAULT_COMPANY_TYPE = 'LIMITED';
export const DEFAULT_ONBOARDING_TYPE = 'STANDARD';
export const DEFAULT_OWNER_TYPE = 'INDIVIDUAL';
export const DEFAULT_PARTNER_NAME = 'celcoin';

